import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Volts: ConvertableUnit = {
  label: "V",
  longLabel: "Volts",
  toStandardUnit: V => V,
  toThisUnit: V => V
};

export const KiloVolts: ConvertableUnit = {
  label: "kV",
  longLabel: "KiloVolts",
  toStandardUnit: kV => kV * 1000,
  toThisUnit: V => V / 1000
};

const unitList = [Volts, KiloVolts];
export const VoltageUnits = {
  Volts,
  KiloVolts,
  options: buildOptions(unitList)
};

/**
 * Switchboard `kv` is catalog voltage in kilovolts (e.g. 0.48 → 480 V).
 * Some rows store line voltage directly in volts (values ≥ ~100).
 */
export function switchboardKvFieldToVolts(kv: number): number {
  if (!Number.isFinite(kv) || kv <= 0) {
    return 0;
  }
  if (kv >= 100) {
    return kv;
  }
  return KiloVolts.toStandardUnit(kv);
}
